import React from 'react';
import { Row, Col } from 'reactstrap';
import _ from 'lodash';
import CallToActionBlock, {
  type CallToActionBlockProps,
} from './CallToActionBlock';

function BlockGroupingOneOne({
  blocks,
}: {
  blocks: { block1: CallToActionBlockProps };
}) {
  const useFixedBackgroundImage = _.get(
    blocks,
    'block1.useFixedBackgroundImage',
    false,
  );
  return (
    <Row className="block-grouping-1 g-0">
      <Col xs={12}>
        <Row className="h-100 g-0">
          <Col className="h-100">
            <CallToActionBlock
              block={blocks.block1 as CallToActionBlockProps}
              className={`${
                useFixedBackgroundImage ? 'grouping-1-fixed-background' : ''
              }`}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default BlockGroupingOneOne;
